import { Platform, View } from "react-native";

import { PANE_THEMES } from "../brand/paneThemes";

const STUDENT_THEME = PANE_THEMES.Student;

/**
 * Ambient brand-glow background. Renders two large, soft, low-opacity
 * radial gradients (forest in one corner, amber in the other) behind
 * page content for atmospheric depth. Pure decoration; pointer events
 * pass through.
 *
 * Web only — react-native-web supports `backgroundImage` directly.
 * Native renders nothing.
 */
export function BrandGlow({
  variant = "default",
}: {
  /** Which corner / palette emphasis to use. */
  variant?: "default" | "warm" | "deep";
}) {
  if (Platform.OS !== "web") return null;

  const presets = {
    default: {
      one: "radial-gradient(ellipse at 0% 0%, rgba(28,43,26,0.07) 0%, transparent 50%)",
      two: "radial-gradient(ellipse at 100% 0%, rgba(181,135,58,0.06) 0%, transparent 55%)",
    },
    warm: {
      one: `radial-gradient(ellipse at 100% 0%, ${STUDENT_THEME.accentTintSoft} 0%, transparent 55%)`,
      two: "radial-gradient(ellipse at 0% 100%, rgba(28,43,26,0.06) 0%, transparent 55%)",
    },
    deep: {
      one: `radial-gradient(ellipse at 50% 0%, ${STUDENT_THEME.border} 0%, transparent 60%)`,
      two: "radial-gradient(ellipse at 100% 100%, rgba(181,135,58,0.05) 0%, transparent 50%)",
    },
  } as const;
  const pal = presets[variant];

  return (
    <>
      <View
        pointerEvents="none"
        style={[
          {
            position: "absolute" as const,
            top: 0,
            left: 0,
            right: 0,
            height: 480,
          },
          { backgroundImage: pal.one } as object,
        ]}
      />
      <View
        pointerEvents="none"
        style={[
          {
            position: "absolute" as const,
            top: 0,
            left: 0,
            right: 0,
            height: 480,
          },
          { backgroundImage: pal.two } as object,
        ]}
      />
    </>
  );
}
